export default function addAutocompletion(inputElement, completionValues) {
    if (!completionValues || completionValues.length === 0 || !inputElement) {
        return;
    }

    var currentFocus = -1, completionList = null, completionWrapper = document.createElement("div");
    completionWrapper.classList.add('autocomplete-wrapper');
    inputElement.parentNode.appendChild(completionWrapper);

    function addActive() {
        if (completionList === null || completionList.childNodes.length < 1) {
            return;
        }

        Array.from(completionList.childNodes).forEach(function (e) {
            e.classList.remove('autocomplete-active');
        });

        if (currentFocus >= completionList.childNodes.length) {
            currentFocus = 0;
        }

        if (currentFocus < 0) {
            currentFocus = completionList.childNodes.length - 1;
        }

        completionList.childNodes.item(currentFocus).classList.add("autocomplete-active");
    }

    function closeAllLists() {
        if (completionList === null) {
            return;
        }
        currentFocus = -1;
        Array.from(completionList.childNodes).forEach(function (element) {
            completionList.removeChild(element);
        });
    }

    inputElement.addEventListener("input", function () {
        var matchingElement, val = this.value;
        closeAllLists();
        if (!val) {
            return;
        }

        if (completionList === null) {
            completionList = document.createElement("div");
            completionList.classList.add('autocomplete-items');
            completionList.classList.add('autocomplete-list');

            completionWrapper.appendChild(completionList);

            inputElement.addEventListener("keydown", function (e) {
                switch (e.keyCode) {
                    case(38): // up arrow
                        if (completionList.childNodes.length > 0) {
                            e.preventDefault();
                        }
                        currentFocus--;
                        addActive(completionList);
                        break;
                    case(40): // down arrow
                        if (completionList.childNodes.length > 0) {
                            e.preventDefault();
                        }
                        currentFocus++;
                        addActive(completionList);
                        break;
                    case(13): // enter
                        if (completionList.childNodes.length > 0) {
                            e.preventDefault();
                        }
                        if (currentFocus > -1 && completionList !== null) {
                            completionList.childNodes.item(currentFocus).click();
                        }
                        currentFocus = -1;
                        break;
                }
            });
        }

        completionValues.forEach((value) => {
            if (value.substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                matchingElement = document.createElement('div');
                matchingElement.innerHTML = "<strong>" + value.substr(0, val.length) + "</strong>";
                matchingElement.innerHTML += value.substr(val.length);
                matchingElement.innerHTML += "<input type='hidden' value='" + value + "'>";

                matchingElement.addEventListener("click", function (e) {
                    inputElement.value = this.getElementsByTagName("input")[0].value;
                    closeAllLists();
                    currentFocus = -1;
                });
                completionList.appendChild(matchingElement);
            }
        });
    });

    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/misc/autocompletion.js